import DetailedSchematic from './DetailedSchematic';

export default DetailedSchematic;
